// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Grid,
//   IconButton,
// } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import TableCells from 'src/components/Tables/TableCells';
// import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useNavigate } from 'react-router';
// import TextInputs from 'src/components/inputs/TextInputs';
// import RadioInputs from 'src/components/inputs/RadioInputs';
// import { AiOutlineInfoCircle } from "react-icons/ai";
// import { MdDelete } from "react-icons/md";
// import { FaRegEdit } from "react-icons/fa";
// import {
//   updateClientInState,
//   removeClientFromState,
//   setCheckedClients,
//   setUpdatedClient,
//   setUpdatedClientData,
//   resetUpdatedClient,
//   setLoading
// } from '../../redux/slices/clientSlice';
// import { useDispatch, useSelector } from 'react-redux';

// export const TrimData = (data) => {
//   if (data?.length < 25) return data;
//   return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
// };

// export const maskData = (value, isMasked) => {
//   if (isMasked) {
//     const maskLength = Math.ceil(value.length / 2);
//     return '*'.repeat(maskLength) + value.substring(maskLength);
//   } else {
//     return value;
//   }
// };


// const FieldData = ({getData}) => {
//   const dispatch = useDispatch();
//   const {
//     filteredClients:data,
//     updatedClientData,
//     updatedClientId,
//     loading,
//     checkedClients
//   } = useSelector((state) => state.clients);
//   const [isAllChecked, setIsAllChecked] = useState(false);
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [updateMask, setUpdateMask] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const { deleteClient, updateClient, setShowMessage, branchData, activeBranchId } = useMain();

//   const navigate = useNavigate();

//   useEffect(() => {
//     setUpdateMask(!updateMask);
//   }, [branchData?.isMasked]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(setUpdatedClientData({ field: name, value }));
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//     dispatch(resetUpdatedClient());
//   };

//   const handleAllCheckboxChange = () => {
//     if (isAllChecked) {
//       dispatch(setCheckedClients([]));
//     } else {
//       dispatch(setCheckedClients(data));
//     }
//     setIsAllChecked(!isAllChecked);
//   };

//     const handleSingleCheckboxChange = (clientId) => {
//     if (checkedClients.some(check => check._id === clientId)) {
//       dispatch(setCheckedClients(checkedClients.filter(check => check._id !== clientId)));
//     } else {
//       const checked = data.filter(item => item._id === clientId);
//       dispatch(setCheckedClients([...checkedClients, ...checked]));
//     }
//   };

//   const handleUpdate = (item) => {
//     dispatch(setUpdatedClient(item));
//     setOpenDialogue(true);
//   };

//   const handleUpdateClientData = async () => {
//     try {
//       dispatch(setLoading(true));
//       const res = await updateClient(
//         updatedClientId,
//         updatedClientData,
//         `?branchId=${activeBranchId}`
//       );
      
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Client Details updated successfully',
//           messageType: 'success',
//         });
//         // Dispatch the updated client data directly
//         dispatch(updateClientInState({ 
//           _id: updatedClientId, 
//           ...updatedClientData 
//         }));
//       } else {
//         setShowMessage({
//           message: res.message || 'Client Details not updated',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something Went Wrong',
//         messageType: 'error',
//       });
//     } finally {
//       dispatch(setLoading(false));
//       handleCloseDialogue();
//     }
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   };

//   const confirmDelete = async () => {
//     try {
//       dispatch(setLoading(true));
//       const res = await deleteClient(deleteId, `?branchId=${activeBranchId}`);
//       if (res?.statusCode === 200) {
//         dispatch(removeClientFromState(deleteId));
//         setShowMessage({
//           message: res.message || 'Client deleted successfully',
//           messageType: 'success',
//         });
//         // getData();
//       } else {
//         setShowMessage({
//           message: res.message || 'Client not deleted',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       dispatch(setLoading(false));
//       setOpenDeleteDialog(false);
//       setDeleteId(null);
//     }
//   };

//  const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//     setDeleteId(null);
//   };

//   const handleDetails = (id) => {
//     navigate(`/client/${id}`);
//   };

//   useEffect(() => {
//     setIsAllChecked((data?.length && checkedClients?.length === data?.length) || false);
//   }, [checkedClients.length, data?.length]);

//   return (
//     <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//       <table className="table-container mt-3">
//         <thead className="table-thead">
//           <tr>
//             <th style={{ width: '20%' }}>
//               <CheckboxInputs
//                 type={'Heading'}
//                 isAllChecked={isAllChecked}
//                 handleAllCheckboxChange={handleAllCheckboxChange}
//               />
//             </th>
//             {[
//               'Name',
//               'Contact Number',
//               'Gender',
//               'Email',
//               'Birthday',
//               'Anniversary',
//               'Bills Amount',
//               'Visit Count',
//               'Avg Ratings',
//               'Actions',
//             ].map((h, index) => {
//               return (
//                 <th key={index} style={{ width: '100%' }}>
//                   {h}
//                 </th>
//               );
//             })}
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {data.map((item) => {
//             const formatDate = (date) => {
//               if (!date) return ''; // Handle empty or null input
//               const isExcelDate = !isNaN(date); // Check if it's a number (Excel date)
              
//               if (isExcelDate) {
//                 // Convert Excel date to JS date
//                 const jsDate = new Date((date - 25569) * 86400 * 1000);
//                 const day = String(jsDate.getDate()).padStart(2, '0');
//                 const month = String(jsDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
//                 const year = jsDate.getFullYear();
//                 return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
//               } else {
//                 // Handle non-Excel dates (assuming they are in "YYYY-MM-DD" format)
//                 const [year, month, day] = date.split('-');
//                 return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
//               }
//             };

//             return (
//               <tr key={item._id}>
//                 <td style={{ width: '20%' }}>
//                   <CheckboxInputs
//                     type={'content'}
//                     handleSignleCheckboxChange={handleSingleCheckboxChange}
//                     checkedItems={checkedClients}
//                     fieldId={item?._id}
//                   />
//                 </td>
//                 <td style={{ width: '100%' }}>{TrimData(item?.clientName)}</td>
//                 <td style={{ width: '100%' }}>
//                   {typeof branchData?.isMasked !== 'boolean' || !item?.clientNumber
//                     ? 'loading...'
//                     : maskData(item?.clientNumber, branchData?.isMasked)}
//                 </td>
//                 <td style={{ width: '100%' }}>{item?.gender}</td>
//                 <td style={{ width: '100%' }}>{item?.clientEmail}</td>
//                 <td style={{ width: '100%' }}>{formatDate(item?.birthday)}</td>
//                 <td style={{ width: '100%' }}>{formatDate(item?.anniversary)}</td>
//                 <td style={{ width: '100%' }}>{item?.totalBillsAmount}</td>
//                 <td style={{ width: '100%' }}>{item?.billsFrequency}</td>
//                 <td style={{ width: '100%' }}>{item?.ratings}</td>
//                 <td style={{
//                   width: '130%'
//                 }}>
//                   <IconButton onClick={() => handleDetails(item._id)} color="primary" title="View Details" style={{ marginRight: '-5px' }}>
//                     <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem', marginLeft: '1.5rem' }} />
//                   </IconButton>
//                   <IconButton onClick={() => handleUpdate(item)} color="secondary" title="Update" style={{ marginRight: '24px' }}>
//                     <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
//                   </IconButton>
//                   <IconButton onClick={() => handleDeleteField(item._id)} color="error" title="Delete" style={{ marginLeft: '-33px' }}>
//                     <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem', marginTop: '1px' }} />
//                   </IconButton>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
//         <DialogContent>
//           Are you sure you want to delete this client?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
//           <Button onClick={confirmDelete} color="secondary">Delete</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ---------------------- Client Details Dialog ---------------- */}
//         <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//         <DialogTitle>Client Details</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Here you can update client details.</DialogContentText>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   title={'Client Name'}
//                   name={'clientName'}
//                   value={updatedClientData?.clientName}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   title={'Contact No'}
//                   name={'clientNumber'}
//                   value={updatedClientData?.clientNumber}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                   maxLength={10}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <RadioInputs
//                   title={'Gender'}
//                   name={'gender'}
//                   value={updatedClientData?.gender}
//                   handleChange={handleInputChange}
//                   options={[
//                     { title: 'M', value: 'Male' },
//                     { title: 'F', value: 'Female' },
//                   ]}
//                   required={false}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   required={false}
//                   title={'Email'}
//                   name={'clientEmail'}
//                   value={updatedClientData?.clientEmail}
//                   handleChange={handleInputChange}
//                   type={'email'}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   required={false}
//                   title={'Address'}
//                   name={'address'}
//                   value={updatedClientData?.clientAddress?.address}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   title={'BirthDay'}
//                   required={false}
//                   name={'birthday'}
//                   value={updatedClientData?.birthday}
//                   handleChange={handleInputChange}
//                   type={'date'}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   required={false}
//                   title={'Anniversary'}
//                   name={'anniversary'}
//                   value={updatedClientData?.anniversary}
//                   handleChange={handleInputChange}
//                   type={'date'}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           {loading ? (
//             <ShowLoader value={loading} />
//           ) : (
//             <>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   target="_blank"
//                   sx={{
//                     background: '#6174DD',
//                   }}
//                   onClick={handleCloseDialogue}
//                 >
//                   Cancel
//                 </Button>
//               </div>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   target="_blank"
//                   sx={{
//                     background: '#6174DD',
//                   }}
//                   onClick={handleUpdateClientData}
//                 >
//                   update
//                 </Button>
//               </div>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default FieldData;

import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  IconButton,
} from '@mui/material';
import { useMain } from '../hooks/useMain';
import TableCells from 'src/components/Tables/TableCells';
import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useNavigate } from 'react-router';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import {
  updateClientInState,
  removeClientFromState,
  setCheckedClients,
  setUpdatedClient,
  setUpdatedClientData,
  resetUpdatedClient,
  setLoading,
  clearCheckedClients
} from '../../redux/slices/clientSlice';
import { useDispatch, useSelector } from 'react-redux';
import { BiNote } from 'react-icons/bi';
import { getHighlightedText } from 'src/utils/textUtils';

export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const fuzzyMatch = (text, search) => {
  if (!search) return true;
  const lowerText = String(text ?? '').toLowerCase().replace(/\s/g, '');
  if (!lowerText) return false;

  const lowerSearch = search.toLowerCase().replace(/\s/g, '');

  let textIndex = 0;
  let searchIndex = 0;
  while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
    if (lowerText[textIndex] === lowerSearch[searchIndex]) {
      searchIndex++;
    }
    textIndex++;
  }
  return searchIndex === lowerSearch.length;
};
const FieldData = ({getData}) => {
  const dispatch = useDispatch();
  const {
     clients,
    filteredClients: paginatedData,
    filters,
    filteredClients:data,
    updatedClientData,
    updatedClientId,
    loading,
    checkedClients,
    pagination
  } = useSelector((state) => state.clients);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [updateMask, setUpdateMask] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [hoveredItemId, setHoveredItemId] = useState(null); // Added hoveredItemId state
  const { deleteClient, updateClient, setShowMessage, branchData, activeBranchId } = useMain();

  const navigate = useNavigate();

  useEffect(() => {
    setUpdateMask(!updateMask);
  }, [branchData?.isMasked]);

   const getAllFilteredClients = () => {
  return clients.filter((item) => {
    const isGenderMatch = filters.genderBy.length === 0 || 
                         filters.genderBy.includes(item?.gender);
    const isSearchMatch = fuzzyMatch(item?.clientName, filters.search) ||
                         fuzzyMatch(item?.clientNumber, filters.search);
    return isGenderMatch && isSearchMatch;
  });
};
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setUpdatedClientData({ field: name, value }));
  };

  // Digits only, removes +91 / 91 country code, max 10 digits
  const cleanPhone = (raw) => {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('91')) {
      digits = digits.slice(2);
    }
    return digits.slice(0, 10);
  };

  const handlePhoneChange = (e) => {
    dispatch(setUpdatedClientData({ field: 'clientNumber', value: cleanPhone(e.target.value) }));
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    dispatch(resetUpdatedClient());
  };

  const handleAllCheckboxChange = () => {
    const currentPageIds = new Set(paginatedData.map((c) => c._id));

    if (isAllChecked) {
      // Uncheck only current page clients, keep other pages' selection
      dispatch(
        setCheckedClients(checkedClients.filter((c) => !currentPageIds.has(c._id)))
      );
    } else {
      // Add current page clients (avoid duplicates)
      const alreadyCheckedIds = new Set(checkedClients.map((c) => c._id));
      const newOnes = paginatedData.filter((c) => !alreadyCheckedIds.has(c._id));
      dispatch(setCheckedClients([...checkedClients, ...newOnes]));
    }
  };

    const handleSingleCheckboxChange = (clientId) => {
  const clientToToggle = paginatedData.find((c) => c._id === clientId);
  if (!clientToToggle) return;

  if (checkedClients.some((c) => c._id === clientId)) {
    dispatch(setCheckedClients(checkedClients.filter((c) => c._id !== clientId)));
  } else {
    dispatch(setCheckedClients([...checkedClients, clientToToggle]));
    }
  };

  useEffect(() => {
    const checkedIds = new Set(checkedClients.map((c) => c._id));
    const allChecked =
      paginatedData.length > 0 &&
      paginatedData.every((c) => checkedIds.has(c._id));

    setIsAllChecked(allChecked);
  }, [checkedClients, paginatedData]);

  const handleUpdate = (item) => {
    dispatch(setUpdatedClient(item));
    setOpenDialogue(true);
  };

  const handleUpdateClientData = async () => {
    try {
      dispatch(setLoading(true));
      const payload = {
        ...updatedClientData,
        clientNumber: cleanPhone(updatedClientData?.clientNumber),
      };

      const res = await updateClient(
        updatedClientId,
        payload,
        `?branchId=${activeBranchId}`
      );
    
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Client Details updated successfully',
          messageType: 'success',
        });
        // Dispatch the updated client data directly
        dispatch(updateClientInState({ 
          _id: updatedClientId, 
          ...payload 
        }));
      } else {
        setShowMessage({
          message: res.message || 'Client Details not updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something Went Wrong',
        messageType: 'error',
      });
    } finally {
      dispatch(setLoading(false));
      handleCloseDialogue();
    }
  };

  const handleDeleteField = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    try {
      dispatch(setLoading(true));
      const res = await deleteClient(deleteId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        dispatch(removeClientFromState(deleteId));
        setShowMessage({
          message: res.message || 'Client deleted successfully',
          messageType: 'success',
        });
        // getData();
      } else {
        setShowMessage({
          message: res.message || 'Client not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      dispatch(setLoading(false));
      setOpenDeleteDialog(false);
      setDeleteId(null);
    }
  };

 const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  const handleDetails = (id) => {
    navigate(`/client/${id}`);
  };
 const clientGridTemplate = '30px 140px 120px 80px 1fr 100px 100px 100px 90px 90px 140px';
  const clientGridRowStyle = {
    display: 'grid',
    gridTemplateColumns: clientGridTemplate,
    alignItems: 'center',
    columnGap: '8px',
  };
  //  useEffect(() => {
  //   const allFilteredClients = getAllFilteredClients();
  //   const allFilteredClientIds = new Set(allFilteredClients.map(client => client._id));
  //   const checkedClientIds = new Set(checkedClients.map(client => client._id));
    
  //   const allChecked = allFilteredClients.length > 0 && 
  //                     allFilteredClients.every(client => checkedClientIds.has(client._id));
    
  //   setIsAllChecked(allChecked);
  // }, [checkedClients, clients, filters, pagination.page]);

  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
      <table className="table-container mt-3" style={{ width: '100%' }}>
        <thead className="table-thead">
          <tr style={clientGridRowStyle}>
            <th>
              <CheckboxInputs
                type={'Heading'}
                isAllChecked={isAllChecked}
                handleAllCheckboxChange={handleAllCheckboxChange}
              />
            </th>
            {[
              'Name',
              'Contact Number',
              'Gender',
              'Email',
              'Birthday',
              'Anniversary',
              'Bills Amount',
              'Visit Count',
              'Avg Ratings',
              'Actions',
            ].map((h, index) => {
              return (
                <th key={index} style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                  {h}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="table-tbody">
          {paginatedData.map((item) => {
            const formatDate = (date) => {
              if (!date) return ''; // Handle empty or null input
              const isExcelDate = !isNaN(date); // Check if it's a number (Excel date)
              
              if (isExcelDate) {
                // Convert Excel date to JS date
                const jsDate = new Date((date - 25569) * 86400 * 1000);
                const day = String(jsDate.getDate()).padStart(2, '0');
                const month = String(jsDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                const year = jsDate.getFullYear();
                return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
              } else {
                // Handle non-Excel dates (assuming they are in "YYYY-MM-DD" format)
                const [year, month, day] = date.split('-');
                return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
              }
            };

            return (
              <tr key={item._id} style={clientGridRowStyle}>
                <td>
                  <CheckboxInputs
                    type={'content'}
                    handleSignleCheckboxChange={handleSingleCheckboxChange}
                    checkedItems={checkedClients}
                    fieldId={item?._id}
                  />
                </td>
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getHighlightedText(TrimData(item?.clientName), filters.search)}</td>
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                  {typeof branchData?.isMasked !== 'boolean' || !item?.clientNumber
                    ? 'loading...'
                    : branchData?.isMasked
                      ? maskData(item?.clientNumber, branchData?.isMasked)
                      : getHighlightedText(item?.clientNumber, filters.search)}
                </td>
                <td style={{ textAlign: 'center' }}>{item?.gender}</td>
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item?.clientEmail}</td>
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{formatDate(item?.birthday)}</td>
                <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{formatDate(item?.anniversary)}</td>
                <td style={{ textAlign: 'center' }}>{item?.totalBillsAmount}</td>
                <td style={{ textAlign: 'center' }}>{item?.billsFrequency}</td>
                <td style={{ textAlign: 'center' }}>{item?.ratings}</td>
                <td style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '0px'
                }}>
                  {/* Notes Button */}
                  {item?.clientNote && (
                    <div style={{ position: 'relative' }}>
                      <IconButton
                        onMouseEnter={() => setHoveredItemId(item._id)}
                        onMouseLeave={() => setHoveredItemId(null)}
                        title="View Notes"
                        size="small"
                        style={{ padding: '2px' }}
                      >
                        <BiNote style={{ color: 'rgb(135 127 127)', fontSize: '1.2rem' }} />
                      </IconButton>

                      {hoveredItemId === item._id && (
                        <div
                          style={{
                            minWidth: '350px',
                            maxWidth: '300px',
                            position: 'absolute',
                            top: '100%', // Position below the icon
                            left: '50%', // Center horizontally
                            transform: 'translateX(-50%)', // Adjust for centering
                            marginTop: '5px', // Add some space below the icon
                            backgroundColor: '#f9f9f9', // Slightly different background
                            border: '1px solid #ddd', // Slightly different border
                            borderRadius: '8px',
                            padding: '10px',
                            zIndex: 1,
                            boxShadow:
                              'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            fontWeight: 'normal', // Ensure normal font weight for the note text
                            color: '#333', // Darker text for better readability
                            textAlign: 'left', // Ensure text alignment is left
                          }}
                        >
                          {item?.clientNote ? item.clientNote : 'No notes'}
                        </div>
                      )}
                    </div>
                  )}
                  <IconButton onClick={() => handleDetails(item._id)} color="primary" title="View Details">
                    <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                  </IconButton>
                  <IconButton onClick={() => handleUpdate(item)} color="secondary" title="Update">
                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteField(item._id)} color="error" title="Delete">
                    <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem', marginTop: '1px' }} />
                  </IconButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogContent>
          Are you sure you want to delete this client?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
          <Button onClick={confirmDelete} color="secondary">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* ---------------------- Client Details Dialog ---------------- */}
        <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
        <DialogTitle>Client Details</DialogTitle>
        <DialogContent>
          <DialogContentText>Here you can update client details.</DialogContentText>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Client Name'}
                  name={'clientName'}
                  value={updatedClientData?.clientName}
                  handleChange={handleInputChange}
                  type={'text'}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'Contact No'}
                  name={'clientNumber'}
                  value={updatedClientData?.clientNumber || ''}
                  handleChange={handlePhoneChange}
                  type={'text'}
                  maxLength={10}
                  required={false}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <RadioInputs
                  title={'Gender'}
                  name={'gender'}
                  value={updatedClientData?.gender}
                  handleChange={handleInputChange}
                  options={[
                    { title: 'M', value: 'Male' },
                    { title: 'F', value: 'Female' },
                  ]}
                  required={false}
                />
              </Grid>
            </Grid>
          </Box>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Email'}
                  name={'clientEmail'}
                  value={updatedClientData?.clientEmail}
                  handleChange={handleInputChange}
                  type={'email'}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Address'}
                  name={'address'}
                  value={updatedClientData?.clientAddress?.address}
                  handleChange={handleInputChange}
                  type={'text'}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextInputs
                  title={'BirthDay'}
                  required={false}
                  name={'birthday'}
                  value={updatedClientData?.birthday}
                  handleChange={handleInputChange}
                  type={'date'}
                />
              </Grid>
            </Grid>
          </Box>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextInputs
                  required={false}
                  title={'Anniversary'}
                  name={'anniversary'}
                  value={updatedClientData?.anniversary}
                  handleChange={handleInputChange}
                  type={'date'}
                />
              </Grid>
            </Grid>
          </Box>
          <Box style={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextInputs
                  title={'Client Note'}
                  name={'clientNote'}
                  value={updatedClientData?.clientNote}
                  handleChange={handleInputChange}
                  type={'text'}
                  required={false}
                  multiline={true}
                  rows={4}
                />
              </Grid>
            </Grid>
          </Box>


        </DialogContent>
        <DialogActions>
          {loading ? (
            <ShowLoader value={loading} />
          ) : (
            <>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleCloseDialogue}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ width: '200px', margin: '3rem auto' }}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleUpdateClientData}
                >
                  update
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FieldData;



